import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-editproject",
  templateUrl: "./editproject.component.html",
  styleUrls: ["./editproject.component.css"],
})
export class EditprojectComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  id: any;
  dropdownSetting0: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  quotationArray: any = [];
  salesArray: any = [];
  TerritoryArray: any = [];
  ProjectArray: any = [];
  StatusArray: any = [];
  ProjectId: string;
  userid: any;
  downloadurl: string;
  url: any = "";
  permission: any;
  ProjectData: any;
  territory: any;
  selectedTerritory: any = [];
  selectedterritory: string = "";
  selectedTerritoryId: string = "";

  optionsPro: string[] = [];
  showProjectArray: any = [];
  ProNameId: Observable<string[]>;
  userRId: any;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService
  ) {}

  // projectPattern = "^[a-zA-Z0-9_ ]+$";

  ngOnInit(): void {
    let decid = this.route.snapshot.params["id"];
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Project_Edit != 1 && this.userRId != 1) {
      this.toastrService.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    localStorage.setItem("editcid", decid);
    this.downloadurl = environment.app_downpath;
    this.url = environment.app_path;
    this.registerForm = this.formBuilder.group({
      ProjectId: [""],
      ProjectName: ["", Validators.required],
      QuotationEngineer: ["", Validators.required],
      SalesEngineer: ["", Validators.required],
      ProjectSource: ["", Validators.required],
      Territory: ["", Validators.required],
      ProjectStatus: ["", Validators.required],
      CreatedBy: this.userid,
    });

    let data = {
      ProjectId: this.id,
    };
    this.UserService.EditProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ProjectId = res["Data"]["ProjectNumber"];

        this.selectedQuotation = [
          {
            id: res["Data"]["QuotationEngineer"],
            itemName: res["Data"]["QuotationEngineerUser"],
          },
        ];
        this.selectedQuotation.forEach((element) => {
          this.selectedEngineer += element["itemName"];
          this.selectedQuotationId += element["id"];
        });

        this.selectedSales = [
          {
            id: res["Data"]["SalesEngineer"],
            itemName: res["Data"]["SalesEngineerUser"],
          },
        ];
        this.selectedSales.forEach((element) => {
          this.selectedsales += element["itemName"];
          this.selectedSalesId += element["id"];
        });

        this.selectedProject = [
          {
            id: res["Data"]["ProjectSource"],
            itemName: res["Data"]["ProjectSourceName"],
          },
        ];
        this.selectedProject.forEach((element) => {
          this.selectedproject += element["itemName"];
          this.selectedProjectId += element["id"];
        });

        this.territory = res["Data"]["TerritoryName"];

        this.selectedTerritory = [
          {
            id: res["Data"]["Territory"],
            itemName: res["Data"]["TerritoryName"],
          },
        ];
        this.selectedTerritory.forEach((element) => {
          this.selectedterritory += element["itemName"];
          this.selectedTerritoryId += element["id"];
        });

        this.selectedStatus = [
          {
            id: res["Data"]["ProjectStatus"],
            itemName: res["Data"]["ProjectStatusName"],
          },
        ];
        this.selectedStatus.forEach((element) => {
          this.selectedstatus += element["itemName"];
          this.selectedStatusId += element["id"];
        });

        this.registerForm.patchValue({
          ProjectId: res["Data"]["ProjectNumber"],
          ProjectName: res["Data"]["ProjectName"],
          Territory: res["Data"]["TerritoryName"],
        });
      }
    });

    this.dropdownSetting0 = {
      singleSelection: true,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Project Source",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: true,
      text: "Project Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.GetProject();
    this.Quotation();
    this.Sales();
    this.GetProjectSource();
    this.Status();
  }

  ProSearchFun(event) {
    let value1 = event.target.value;
    this.ProNameId = this.registerForm.controls[
      "ProjectName"
    ].valueChanges.pipe(
      startWith(""),
      map((value: string) => this._filterPro(value1 || ""))
    );
  }
  private _filterPro(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsPro.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  GetProject() {
    this.optionsPro = [];
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        this.optionsPro = [];
        for (const projectData of this.showProjectArray["Data"]) {
          if (
            projectData["Status"] == 1 &&
            (projectData["ProjectStatus"] == 4 ||
              projectData["ProjectStatus"] == 6)
          ) {
            this.optionsPro.push(projectData["ProjectName"]);
          }
        }
      } else {
        this.optionsPro = [];
      }
    });
  }

  quotation: any = [];
  Quotation() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.quotationArray = res;
        this.quotation = [];
        for (const quotationData of this.quotationArray["Data"]) {
          this.quotation.push({
            id: quotationData["UserId"],
            itemName: `${quotationData["UserName"]} (${quotationData["EmailId"]}) ${quotationData["EmployeeId"]}`,
          });
        }
      } else {
        this.quotationArray = [];
      }
    });
  }
  selectedQuotation: any = [];
  selectedEngineer: string = "";
  selectedQuotationId: string = "";
  onQuotationSelect(item: any) {
    this.selectedEngineer = "";
    this.selectedQuotationId = "";
    this.selectedQuotation.forEach((element) => {
      this.selectedEngineer += element["itemName"];
      this.selectedQuotationId += element["id"];
    });
  }

  sales: any = [];
  Sales() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.salesArray = res;
        this.sales = [];
        for (const salesData of this.salesArray["Data"]) {
          this.sales.push({
            id: salesData["UserId"],
            itemName: `${salesData["UserName"]} (${salesData["EmailId"]}) ${salesData["EmployeeId"]}`,
          });
        }
      } else {
        this.salesArray = [];
      }
    });
  }
  selectedSales: any = [];
  selectedsales: string = "";
  selectedSalesId: string = "";
  onSalesSelect(item: any) {
    this.selectedsales = "";
    this.selectedSalesId = "";
    this.selectedSales.forEach((element) => {
      this.selectedsales += element["itemName"];
      this.selectedSalesId += element["id"];
    });
  }

  project: any = [];
  GetProjectSource() {
    let data = {};
    this.UserService.GetProjectSource(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ProjectArray = res;
        this.project = [];
        for (const projectData of this.ProjectArray["Data"]) {
          this.project.push({
            id: projectData["Id"],
            itemName: projectData["ProjectSource"],
          });
        }
      } else {
        this.ProjectArray = [];
      }
    });
  }
  selectedProject: any = [];
  selectedproject: string = "";
  selectedProjectId: string = "";
  onProjectSelect(item: any) {
    this.selectedproject = "";
    this.selectedProjectId = "";
    this.selectedProject.forEach((element) => {
      this.selectedproject += element["itemName"];
      this.selectedProjectId += element["id"];
    });
  }

  status: any = [];
  Status() {
    let data = {};
    this.UserService.GetProjectStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.StatusArray = res;
        this.status = [];
        for (const statusData of this.StatusArray["Data"]) {
          this.status.push({
            id: statusData["StatusID"],
            itemName: statusData["StatusName"],
          });
        }
      } else {
        this.StatusArray = [];
      }
    });
  }
  selectedStatus: any = [];
  selectedstatus: string = "";
  selectedStatusId: string = "";
  onStatusSelect(item: any) {
    this.selectedstatus = "";
    this.selectedStatusId = "";
    this.selectedStatus.forEach((element) => {
      this.selectedstatus += element["itemName"];
      this.selectedStatusId += element["id"];
    });
  }

  onItemSelect(item: any) {}
  OnItemDeSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  onSubmit() {
    this.submitted = true;
    let data = {
      ProjectId: this.id,
      ProjectName: this.registerForm.value.ProjectName,
      QuotationEngineer: this.selectedQuotationId,
      SalesEngineer: this.selectedSalesId,
      ProjectSource: this.selectedProjectId,
      Territory: this.selectedTerritoryId,
      ProjectStatus: this.selectedStatusId,
    };
    if (this.registerForm.valid) {
      this.UserService.AddUpdate(data).subscribe((res) => {
        this.spinner.show();
        if (res["result"] == "success") {
          this.spinner.hide();
          this.toastrService.success(
            "Project " + res["Data"]["ProjectNumber"] + " Save Successfully"
          );
          this.router.navigate(["/project/projectlist"]);
        } else if (res["result"] == "Failed") {
          this.toastrService.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastrService.error(res["Message"]);
          this.spinner.hide();
        }
        this.submitted = false;
      });
    }
  }
  editcid = this.route.snapshot.params["id"];

  //space not allowed
  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }
}
